import oneStrom from '@components/images/recommender/oneperson.include.svg';
import twoStrom from '@components/images/recommender/twopersons.include.svg';
import threeStrom from '@components/images/recommender/threepersons.include.svg';
import fourStrom from '@components/images/recommender/fourpersons.include.svg';
import fourMoreStrom from '@components/images/recommender/fourandmorepersons.include.svg';
import smallGas from '@components/images/recommender/thirty_squaremeters.include.svg';
import mediumGas from '@components/images/recommender/fifty_squaremeters.include.svg';
import largeGas from '@components/images/recommender/hundert_squaremeters.include.svg';
import xLargeGas from '@components/images/recommender/hundertfifty_squaremeters.include.svg';
import xxLargeGas from '@components/images/recommender/twohundred_squaremeters.include.svg';

const tankeType = {
  minKwhUsage: 5,
  maxKwhUsage: 35,
  defaultKwhUsage: 17,
  minUsage: 25,
  maxUsage: 100000,
  defaultUsage: 1000,
  showLimitAsBox: true,
  limit: 100000,
  calculate: () => 8000,
  images: () => null,
};

/**
 * @ignore
 */
const productTypes = {
  strom: {
    showCounter: true,
    min: 1,
    max: 5,
    limit: 40000,
    labelContext: `Personen`,
    getLabel: value =>
      `${value} ${
        value > 1 ? (value === 5 ? 'Personen & mehr' : 'Personen') : 'Person'
      }`,
    calculate: value => {
      const definitions = [1300, 2300, 3300, 4300, 5300];
      return definitions[Math.max(value, 1) - 1] || 1300;
    },
    iterateResetValues: callback => {
      const values = {
        ecoMode: false,
        priceGuarantee: false,
        zipcode: '',
        count: 2,
        usage: 2300,
      };

      if (callback && typeof callback === 'function') {
        Object.keys(values).forEach(key => {
          callback(key, values[key]);
        });
      }
    },
    images: ({ count }) => {
      const definitions = [
        { value: 1, icon: oneStrom },
        { value: 2, icon: twoStrom },
        { value: 3, icon: threeStrom },
        { value: 4, icon: fourStrom },
        { value: 5, icon: fourMoreStrom },
      ];
      let active = 0;
      definitions.forEach((item, index) => {
        if (item.value <= count) {
          active = index;
        }
      });
      return definitions[active].icon;
    },
  },
  gas: {
    showCounter: true,
    min: 1,
    max: 5,
    limit: 40000,
    labelContext: 'Wohnfläche',
    getLabel: value => {
      const definitions = [
        { value: 30 },
        { value: 50 },
        { value: 100 },
        { value: 150 },
        { value: 200, text: `200 m² & mehr` },
      ];

      return (
        definitions[value - 1].text || `${definitions[value - 1].value} m²`
      );
    },
    calculate: value => {
      const definitions = [4000, 7000, 14000, 20000, 30000];
      return definitions[Math.max(value, 1) - 1] || definitions[0];
    },
    iterateResetValues: callback => {
      const values = {
        ecoMode: false,
        priceGuarantee: false,
        zipcode: '',
        count: 2,
        usage: 7000,
      };

      if (callback && typeof callback === 'function') {
        Object.keys(values).forEach(key => {
          callback(key, values[key]);
        });
      }
    },
    images: ({ count }) => {
      const definitions = [
        smallGas,
        mediumGas,
        largeGas,
        xLargeGas,
        xxLargeGas,
      ];
      return definitions[count - 1];
    },
  },
  business_strom: {
    showCounter: false,
    showLimitAsBox: true,
    limit: 100000,
    calculate: () => 6000,
    images: () => null,
  },
  business_gas: {
    showCounter: false,
    showLimitAsBox: true,
    limit: 100000,
    calculate: () => 8000,
    images: () => null,
  },
  // TODO
  tanke: tankeType,
  business_tanke: tankeType,
};
export default productTypes;
